import {
  AfterContentChecked,
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {AlertService} from "../../../services/alert.service";
import {DomSanitizer} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";
import {Selected} from "../../../model/Selected";
import {Utils} from "../../../model/Utils";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {IMultiSelectItem} from "./IMultiSelectItem";

@Component({
  selector: 'multiSelectDropdown',
  templateUrl: './MultiSelectDropdownComponent.html',
  styleUrls: ['./MultiSelectDropDownComponent.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectDropdownComponent),
      multi: true
    }
  ]
})

export class MultiSelectDropdownComponent implements AfterViewInit,AfterViewChecked,AfterContentInit,AfterContentChecked, ControlValueAccessor, OnChanges {

  @ViewChild('controlContent')
  contentComponent :ElementRef;

  @Input()
  selectLabelCode: string;

  @Input()
  noSelectionAvailableLabelCode: string;

  @Input()
  itemSelectedLabelCode: string;

  @Input()
  nbSelectedMax = 2;

  @Input()
  modelToSelectFrom = new Array<IMultiSelectItem>();

  selectableModel = new Array<Selected<IMultiSelectItem>>();

  public doubleLine = false;

  public disabled = false;

  private _selectedIds = new Array();

  private _onTouchedCallback: any = () => {};
  private _onChangedCallback: any = () => {};

  //
  // @Output() remove = new EventEmitter();
  // @Output() edit = new EventEmitter();

  private _displayContent = false;

  private _oldHeight = -1;

  constructor(
    private renderer: Renderer2,
    @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
    @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
    @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => Router)) private router: Router,
    @Inject(forwardRef(() => SessionService)) private session: SessionService,
    @Inject(forwardRef(() => TranslateService)) private translateService: TranslateService
  ) {

  }

  ngAfterContentChecked(): void {
    // console.log('AfterContentChecked');
    // this._displaySize();
    this._checkSize();
    }

  ngAfterContentInit(): void {
    // console.log('AfterContentInit');
    // this._displaySize();
    }

  ngAfterViewChecked(): void {
    // console.log('AfterViewChecked');
    // this._displaySize();
    // this._checkSize();
  }

    private _checkSize(){
      if (this.contentComponent){
        if (this._selectedIds && this._selectedIds.length===0){
          this._oldHeight = this.contentComponent.nativeElement.offsetHeight;
        }
        if (this.contentComponent.nativeElement.offsetHeight>this._oldHeight){
          this.doubleLine = true;
        }else{
          this.doubleLine = false;
        }
        /*
        if (this._oldHeight<=0){
          this._oldHeight = this.contentComponent.nativeElement.offsetHeight;
        }else{
          if (this.contentComponent.nativeElement.offsetHeight>this._oldHeight){
            this.doubleLine = true;
          }else{
            this.doubleLine = false;
          }
        }

         */
       //  console.log(this._oldHeight + ", " + this.contentComponent.nativeElement.offsetHeight + ' doubleLine: ' + this.doubleLine);
      }
    }

    private _displaySize(){
      console.log('NativeElement: ',this.contentComponent.nativeElement);
      // const box = this.contentComponent.nativeElement.querySelector('.box');
      // console.log('Box: ',box);
      console.log('NativeElement OffsetWidth: ',this.contentComponent.nativeElement.offsetWidth);
      console.log('NativeElement OffsetHeight: ',this.contentComponent.nativeElement.offsetHeight);

    }

    writeValue(obj: any): void {
        // console.log('WriteValues ',obj)
      if (!obj){
        return;
      }
        this._selectedIds = obj;
      this._resetSelectableModel();
    }
    registerOnChange(fn: any): void {
        this._onChangedCallback = fn;
        // throw new Error("Method not implemented.");
    }
    registerOnTouched(fn: any): void {
        this._onTouchedCallback = fn;
        //throw new Error("Method not implemented.");
    }
    setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
        // throw new Error("Method not implemented.");
    }



  ngAfterViewInit(): void {
    /*
    this.renderer.listen(this.contentComponent,'click',(event)=>{
      console.log('Event : ',event);
    })

     */
    /*
   this._resizeObserver = new ResizeObserver((entries)=>{
          entries.forEach((entry)=>{
            console.log('Resizing2: ',entry);
            if (this._oldHeight<=0){
              this._oldHeight = entry.contentRect.height;
            }else{
              if (entry.contentRect.height>this._oldHeight){
                this.doubleLine = true;
              }else{
                this.doubleLine = false;
              }
            }
            console.log(this._oldHeight + ", " + entry.contentRect.height + ' doubleLine: ' + this.doubleLine);
          })
    })
    console.log('contentComponent: ',this.contentComponent);
    this._resizeObserver.observe(this.contentComponent.nativeElement);

     */

    // console.log('contentComponent: ',document.getElementById('#contentComponent'));
    // this._resizeObserver.observe(document.getElementById('contentComponent'));

    /*
    setTimeout(() => {
      this.tree.selectItem(null);
    });

     */
  }


  ngOnChanges(changes: SimpleChanges): void {
      console.log('OnChanges: ', changes);
      this._resetSelectableModel();
  }

  private _resetSelectableModel(){



    if (this.modelToSelectFrom){
      this.selectableModel = new Array<Selected<IMultiSelectItem>>();
      for (const t of this.modelToSelectFrom){
        this.selectableModel.push(new Selected<IMultiSelectItem>(t,false));
      }

      if (!this.disabled){
        for (const id of this._selectedIds){
          // console.log('Looking for ' + id);
          for (const item of this.selectableModel){
            if (id===item.data.id){
              // console.log('Found ' + id);
              item.selected = true;
              break;
            }
          }
        }
       // console.log('SelectedIds: ',this._selectedIds);
      }
    }
  }



  get selectedLabel(){
    if (this.selected.length>this.nbSelectedMax){
      if (!Utils.isEmpty(this.itemSelectedLabelCode)){
        return this.translateService.instant(this.itemSelectedLabelCode,{nb:this.selected.length});
      }else{
        return this.translateService.instant('ItemsSelected',{nb:this.selected.length})
      }
    }
  }

  get selectPlaceHolder(){
    if (!Utils.isEmpty(this.selectLabelCode)){
      return this.translateService.instant(this.selectLabelCode);
    }else{
      return this.translateService.instant('SelectAnItem');
    }
  }

  get noSelectionAvailable(){
    if (!Utils.isEmpty(this.noSelectionAvailableLabelCode)){
      return this.translateService.instant(this.noSelectionAvailableLabelCode);
    }else{
      return this.translateService.instant('NoSelectionAvailable');
    }
  }

  get selected(){
    const res = new Array()
    if (this.selectableModel){
      for (const item of this.selectableModel){
        if (item.selected){
          res.push(item);
        }
      }
    }
    return res;
  }

  get displayContent(): boolean {
    return this._displayContent;
  }

  public showContent(){
    this._displayContent = true;
  }
  public toggleContent(){
    this._displayContent = !this._displayContent;
  }

  public hideContent(){
    this._displayContent = false;
  }
  public unSelectItem(event:any,item:Selected<IMultiSelectItem>){
    event.stopPropagation();
    item.selected = false;
    this._writeSelected();
  }
  /*
  public selectItem(item:Selected<IMultiSelectOption>){
    item.selected = true;
    this._writeSelected();
  }

   */

  onItemChanged(item:Selected<IMultiSelectItem>){
    console.log(item.selected + ", " + item.data.id + ': ' + item.data.name)
    item.selected = !item.selected;
    this._writeSelected();
  }

  private _writeSelected(){
    if (!this.disabled){
      // if (this._selectedIds){
      //
      //
      // }
      for (const item of this.selectableModel){
        if (item.selected){
          if (this._selectedIds.indexOf(item.data.id)===-1){
            this._selectedIds.push(item.data.id);
          }
        }else if (item.selected===false){
          const idx = this._selectedIds.indexOf(item.data.id);
          if (idx>=0){
            this._selectedIds.splice(idx,1);
          }
        }
      }
      // console.log('Selected Items are: ',this._selectedIds);

      this._onChangedCallback(this._selectedIds);
      this._onTouchedCallback();
      /*
      console.log('NativeElement: ',this.contentComponent.nativeElement);
      // const box = this.contentComponent.nativeElement.querySelector('.box');
      // console.log('Box: ',box);
      console.log('NativeElement OffsetWidth: ',this.contentComponent.nativeElement.offsetWidth);
      console.log('NativeElement OffsetHeight: ',this.contentComponent.nativeElement.offsetHeight);
      */

    }
  }


}

